<template>
  <Head :title="__(title)" />
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                
        <div class="flex items-center justify-end w-full px-8 py-4">
          <loading-button class="border-gray-100 px-8 py-4" style="background-color: #7366ff;color:white;border-radius: 10px;">
            <a :href="import_formate"  target="__blank" download="students.csv">{{ __('Download Import Template') }}</a>
          </loading-button>
        </div>     
        <div class="w-full">
          <file-input v-model="file" :error="fileError" class="pb-8 pr-6 w-6/12 lg:w-1/2" type="file" label="Import File" />
          <loading-button @click="importFile" class="border-gray-100 px-8 py-4 mb-2" style="background-color: #7366ff; color: white; border-radius: 10px;">
            Submit File
          </loading-button>
        </div>
        <!-- <input type="file" @change="importFile" /> -->
      </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import { Inertia } from '@inertiajs/inertia'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'

export default {
  components: {
      SearchInput,
    Head,
    Icon,
    Link,
      Pagination,
      LoadingButton,
      FileInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Object,
    import_formate: String,
  },
  data() {
    return {
      file: null,
      fileError: '',
    }
  },
  watch: {
    
  },
  methods: {
    importFile() {
     
            if (!this.file) {
              this.fileError = 'Please select a file to upload.';
              alert('Please select a file to upload.');
              return;
            }
            const formData = new FormData();
            formData.append('file', this.file);
            
            Inertia.post(route('importStudents'), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(() => {
                alert('File imported successfully');
            })
            .catch(error => {
                alert('There was an error uploading the file:', error);
            });
  },
}
}
</script>

